import { IById, ISelectable } from "@timesheets/webapp-support";

import Vue from "vue";
import { assert } from "@gemma/utils";
import { RecordAny } from "@gemma/typescript-types";

type ExtensibleVue = Vue & Record<string, any>;

export function select<TItem extends IById, TMappedItem extends ISelectable>(
  //
  mappedCollectionName: string,
  selectedItemName: string,
  {
    initialValue,
    onMultipleItems,
    selectByDefault = true,
  }: {
    initialValue?: TItem;
    onMultipleItems?: (this: ExtensibleVue, currentSelectedItem: TMappedItem | undefined, newItems: TItem[]) => TMappedItem | undefined;
    selectByDefault: boolean;
    reload?: () => void;
  } = {
    selectByDefault: true,
  }
) {
  return {
    data() {
      return {
        [selectedItemName]: initialValue,
        [mappedCollectionName + "_reloading"]: true,
      };
    },
    computed: {
      reloading() {
        const mappedCollection = (<RecordAny>this)[mappedCollectionName] || ((<RecordAny>this)[mappedCollectionName] = []);
        const reload = mappedCollection["reload"];

        return reload ? { reload, mappedCollectionName } : undefined;
      },
    },
    watch: {
      reloading(this: ExtensibleVue, newValue: { reload?: boolean; mappedCollectionName: string } | undefined) {
        if (newValue) {
          const propertyName = newValue.mappedCollectionName + "_reloading";
          this[propertyName] = newValue.reload;
        }
      },
      [mappedCollectionName](this: ExtensibleVue, newCollection: TItem[]): void {
        if (this[mappedCollectionName + "_reloading"]) {
          if (newCollection.length === 0 && this[selectedItemName]) {
            this[selectedItemName] = undefined;
          } else if (newCollection.length === 1) {
            const first = this[mappedCollectionName][0];
            if (!this[selectedItemName] || this[selectedItemName].id !== first.id) {
              this[selectedItemName] = first;
            }
          }

          this[mappedCollectionName + "_reloading"] = false;
        } else if (onMultipleItems) {
          const newValue = onMultipleItems.call(this, this[selectedItemName], newCollection);
          if (newValue && newValue.id !== (this[selectedItemName] as IById).id) {
            this[selectedItemName] = newValue;
          }
        }
      },
    },
    methods: {
      resetSelected(this: ExtensibleVue, mappedCollectionNameToReset: string, selectedItemNameToReset: string): void {
        assert.ok(mappedCollectionNameToReset && Array.isArray(this[mappedCollectionNameToReset]), mappedCollectionNameToReset + " collection property missing");
        assert.ok(selectedItemNameToReset && Object.prototype.hasOwnProperty.call(this, selectedItemNameToReset), selectedItemNameToReset + "property  missing");

        const mappedCollection = (this[mappedCollectionNameToReset] as unknown) as TItem[];
        if (mappedCollection.length === 0) {
          this[selectedItemNameToReset] = undefined;
        } else if (mappedCollection.length === 1 && selectByDefault) {
          this[selectedItemNameToReset] = mappedCollection[0];
        } else if (onMultipleItems) {
          const newValue = onMultipleItems.call(this, this[selectedItemNameToReset], mappedCollection);
          if (newValue) {
            this[selectedItemNameToReset] = newValue;
          }
        }
      },
      reloadSelect() {},
    },
  };
}
